import { useState } from 'react';
import { Button } from '@savvy-kit/components/button';
import { ArchiveIcon } from 'lucide-react';

import { ArchivedClientsDialog } from './archived-clients-dialog';

export function ArchivedButton() {
  const [showArchived, setShowArchived] = useState(false);

  const handleShowArchived = () => {
    setShowArchived((prev) => !prev);
  };

  return (
    <ArchivedClientsDialog
      onClose={handleShowArchived}
      open={showArchived}
      dialogTriggerRender={
        <Button onClick={handleShowArchived} variant="secondary" icon={<ArchiveIcon size={16} />}>
          Archived
        </Button>
      }
    />
  );
}
